import React,{useState} from 'react'
import {api} from "../app/Api/ApiSlice.js"
import {useNavigate} from "react-router-dom"
import {toast} from "react-toastify"
import officeImg from "../assets/office.png"

const ActionsOrgCard = ({org}) => {
    const [loadingMRequest,setLoadingMRequest] = useState(false)
    const [loadingFRequest,setLoadingFRequest] = useState(false)

    const navigate = useNavigate()


   const joinAsMember = async(orgName)=>{
        try {
            setLoadingMRequest(true)
            const response = await api.post(`/${orgName}/members/join`)
            if(response){
                setLoadingMRequest(false)
                toast.success("membership request sent")
            }
        } catch (error) {
            setLoadingMRequest(false)
            toast.error(error.response.data.message);
        }
    }
    const joinAsFriend = async(orgName)=>{
        try {
            setLoadingFRequest(true)
            const response = await api.post(`/${orgName}/friends/join`)
            console.log(response)
            if(response){
                setLoadingFRequest(false)
                toast.success("friendship request sent")
            }
        } catch (error) {
            setLoadingFRequest(false)
            toast.error(error.response.data.message);
        }
    }
    const followOrg = async(orgName,orgId)=>{
        try {
            setLoadingFRequest(true)
            const response = await api.post(`/${orgName}/follow`,{orgId})
            if(response){
                setLoadingFRequest(false)
                toast.success(`${orgName} followed`)
            }
        } catch (error) {
            setLoadingFRequest(false)
            toast.error(error.response.data.message);
        }
    }
  return (
    <div className='org-card'>
                                <div className="org-card-body">
                                    <div className="org-image">
                                        <img src={org?.profilePic ? org.profilePic : officeImg} alt={org.profilePic} />
                                    </div>
                                    <div className="org-info">
                                        <h1
                                            className="org-name linking"
                                            onClick={() => navigate(`/${encodeURIComponent(org?.name)}`, { state: { org } })}
                                        >
                                            {org?.name}
                                        </h1>
                                        <div className="org-bio">
                                            <p>{org.description}</p>
                                        </div>
                                        <div className="org-community">
                                        <p>Members{`(${org?.membersCount})`}</p>
                                        <p>Friends{`(${org?.friendsCount})`}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="org-actions-btn">
                                    <button onClick={()=>joinAsMember(org.name)} className='action-btn'>{!loadingMRequest?"member":"Loading..."}</button>
                                    <button onClick={()=>joinAsFriend(org.name)} className='action-btn'>{!loadingFRequest?"friend":"Loading..."}</button>
                                    <button onClick={()=>followOrg(org.name,org._id)} className='action-btn'>Follow</button>
                                </div>
                            </div>
  )
}

export default ActionsOrgCard
